import { track } from '@zillow/universal-analytics';
import { isHappyOutcome } from './calculations';
import { INPUTS } from './constants';

const VISIBLE_INPUTS = [
    INPUTS.annualIncome,
    INPUTS.monthlyDebts,
    INPUTS.downPayment,
    INPUTS.creditScore,
    INPUTS.cityOrZip,
];

export const trackGAMortgageEvent = (action, label) =>
    track({
        category: 'Mortgages',
        action,
        label,
    });

// TODO ZHLrates with the new api
export const trackGACalculatorOutcome = data => {
    const outcomeState = isHappyOutcome(data?.outcome) ? 'happy' : 'unhappy';
    trackGAMortgageEvent('Budget Calculator: Interaction', `Calculator Outcome "${outcomeState}", "ZGMIrates"`);
};

export const trackGACalculatorVisible = () => {
    trackGAMortgageEvent('Budget Calculator: Impression', `[${VISIBLE_INPUTS.join(', ')}]`);
};

export const trackGAFieldFocus = field => {
    trackGAMortgageEvent('Budget Calculator: Interaction', `Calculator Edit "${field}"`);
};
